// MGRDAYMAJ1 (manager-day-07): the words on the Finalize confirmation. A confirmation names the actual thing affected, so the
// title, the first line and the button all say which day is about to be recorded and what is in it. Pure and DOM free, so a
// plain node:test file can import it. Money comes from the summary the sheet already holds; nothing is computed here but text.

import { formatCents } from "./money.ts";
import { dayLabel } from "./reportFormat.ts";

export interface FinalizeWordsInput {
  /** The business day being finalized, YYYY-MM-DD. */
  readonly businessDate: string;
  readonly netSalesCents: number;
  /** The cash drawer's over or short for the day; absent for a person who may not see it, or a location with no cash. */
  readonly overShortCents?: number | undefined;
  /** The tabs that would carry over to the next day. */
  readonly carryoverCount: number;
}

export interface FinalizeWords {
  readonly title: string;
  readonly summary: string;
  readonly confirm: string;
}

/** "Tue Oct 27" -> "Oct 27". */
function monthDay(date: string): string {
  return dayLabel(date).split(" ").slice(1).join(" ");
}

export function finalizeWords(input: FinalizeWordsInput): FinalizeWords {
  const parts = [`Net sales ${formatCents(input.netSalesCents)}`];
  const drawer = input.overShortCents;
  if (drawer !== undefined && drawer !== 0) {
    parts.push(`drawer ${formatCents(Math.abs(drawer))} ${drawer < 0 ? "short" : "over"}`);
  }
  parts.push(
    input.carryoverCount === 0
      ? "no tabs carry over"
      : `${input.carryoverCount} ${input.carryoverCount === 1 ? "tab carries" : "tabs carry"} over`,
  );
  return {
    title: `Finalize ${dayLabel(input.businessDate)}?`,
    summary: `${parts.join(", ")}.`,
    confirm: `Finalize ${monthDay(input.businessDate)}`,
  };
}
